var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
const SvgKey = (_ref, ref) => {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 30,
    height: 30,
    fill: "none",
    viewBox: "0 0 30 30",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#A5A5A5",
    fillRule: "evenodd",
    d: "M9.375 18.75a1.875 1.875 0 1 0 0 3.75 1.875 1.875 0 0 0 0-3.75m-3.75 1.875a3.75 3.75 0 1 1 7.5 0 3.75 3.75 0 0 1-7.5 0",
    clipRule: "evenodd"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#A5A5A5",
    fillRule: "evenodd",
    d: "M22.775.275A.94.94 0 0 1 23.438 0h5.625c.517 0 .937.42.937.938v5.625a.94.94 0 0 1-.275.662L27.85 9.1a.94.94 0 0 1-.663.275H22.5v4.688a.94.94 0 0 1-.275.662l-3.758 3.758c.169.67.283 1.385.283 2.142a9.376 9.376 0 1 1-9.375-9.375c.757 0 1.472.114 2.142.283zm1.05 1.6-11.368 11.37a.94.94 0 0 1-.932.234c-.717-.214-1.425-.354-2.15-.354a7.5 7.5 0 1 0 7.5 7.5c0-.725-.14-1.433-.354-2.15a.94.94 0 0 1 .235-.932l3.869-3.869V8.438c0-.518.42-.938.938-.938h5.236l1.326-1.326V1.875z",
    clipRule: "evenodd"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgKey);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/key.ec51c2fe.svg";